import React from 'react';
import './TechMarquee.css';
import {
  SiReact, SiNextdotjs, SiSolid, SiTypescript, SiJavascript,
  SiNodedotjs, SiExpress, SiPython, SiRust, SiFastapi, SiFlask,
  SiPostgresql, SiMysql, SiMongodb, SiOpencv, SiOpenai, SiWebrtc,
  SiDocker, SiGithubactions, SiLinux, SiGit, SiNetlify, SiVercel,
} from 'react-icons/si';

const TECHS = [
  { icon: <SiReact />, name: 'React.js' },
  { icon: <SiNextdotjs />, name: 'Next.js' },
  { icon: <SiSolid />, name: 'SolidJS' },
  { icon: <SiTypescript />, name: 'TypeScript' },
  { icon: <SiJavascript />, name: 'JavaScript' },
  { icon: <SiNodedotjs />, name: 'Node.js' },
  { icon: <SiExpress />, name: 'Express.js' },
  { icon: <SiPython />, name: 'Python' },
  { icon: <SiRust />, name: 'Rust' },
  { icon: <SiFastapi />, name: 'FastAPI' },
  { icon: <SiFlask />, name: 'Flask' },
  { icon: <SiPostgresql />, name: 'PostgreSQL' },
  { icon: <SiMysql />, name: 'MySQL' },
  { icon: <SiMongodb />, name: 'MongoDB' },
  { icon: <SiOpencv />, name: 'OpenCV' },
  { icon: <SiOpenai />, name: 'OpenAI API' },
  { icon: <SiWebrtc />, name: 'WebRTC' },
  { icon: <SiDocker />, name: 'Docker' },
  { icon: <SiGithubactions />, name: 'GitHub Actions' },
  { icon: <SiLinux />, name: 'Linux' },
  { icon: <SiGit />, name: 'Git' },
  { icon: <SiNetlify />, name: 'Netlify' },
  { icon: <SiVercel />, name: 'Vercel' },
];

const TechMarquee = () => {
  const doubled = [...TECHS, ...TECHS];

  return (
    <div className="marquee-wrapper" aria-hidden="true">
      <div className="marquee-label">Tech Stack</div>
      <div className="marquee-track-wrap">
        <div className="marquee-fade-left" />
        <div className="marquee-track">
          {doubled.map((tech, i) => (
            <div className="marquee-item" key={i}>
              <span className="marquee-icon">{tech.icon}</span>
              <span className="marquee-name">{tech.name}</span>
            </div>
          ))}
        </div>
        <div className="marquee-fade-right" />
      </div>
    </div>
  );
};

export default TechMarquee;
